export default "__VITE_ASSET__Bc1N7gEx__"